import React from 'react'
import { IconX } from '@tabler/icons-react'
import cssModule from '../Dropzone.module.css'

export default function Thumbs({ files, onThumbClick, onRemove }) {
  return files.map((file, index) => (
    <div className={cssModule.dropzone_thumb} key={file.preview}>
      <div className={cssModule.dropzone_thumb_inner}>
        <div className={cssModule.dropzone_thumb_inner_div}>
          <button
            type="button"
            className={cssModule.dropzone_thumb_open}
            onClick={() => onThumbClick?.(index)}
            aria-label={`Προβολή εικόνας ${index + 1}`}
          >
            <img
              src={file.preview}
              alt={`Thumbnail ${index + 1}`}
              className={cssModule.dropzone_thumb_inner_img}
            />
          </button>
          {onRemove && (
            <button
              type="button"
              className={cssModule.dropzone_thumb_remove}
              onClick={(e) => {
                e.stopPropagation()
                onRemove(index)
              }}
              aria-label={`Αφαίρεση εικόνας ${index + 1}`}
              title="Αφαίρεση"
            >
              <IconX className="size-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  ))
}
